// Libraries
var React = require('react');

// Assets
var PlaceholderImg = require('images/blankImgPlaceholder.png');

// Styles
require('./SocialLinks.scss');

class SocialLinksModule extends React.Component {
	render() {
		return (	
			<div className={"social-links"}>
				<div className={"social-links__wrapper"}>
					{this.props.data.links &&
						<ul>
							{this.props.data.links.map((item, index) => {
								return(
									<li key={index}>
										<a href={item.link.url} target={item.link.newWindow ? "_blank" : "_self"} rel={item.link.newWindow ? "noopener noreferrer" : undefined}>
											{item.image &&
												<img src={PlaceholderImg} data-src={item.image.smallUrl} alt={item.image.altText} />
											}
										</a>
									</li>);
							})}
						</ul>
					}
				</div>
			</div>
		)
	}
}

module.exports = SocialLinksModule;



// WEBPACK FOOTER //
// ./src/components/Footer/SocialLinks/SocialLinksModule.js